"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithSelectedVariantStore = void 0;
var react_1 = __importDefault(require("react"));
var selected_variant_state_1 = require("./selected-variant-state");
/**
 * Higher order component that allows class components to use the selected variant Zustand store
 *
 * @todo convert remaining React class components to functional components so this isn't necessary
 * */
function WithSelectedVariantStore(WrappedComponent) {
    var ComponentWithStore = function (props) {
        var store = (0, selected_variant_state_1.useSelectedVariantStore)();
        return react_1.default.createElement(WrappedComponent, __assign({}, props, { selectedVariantStore: store }));
    };
    return ComponentWithStore;
}
exports.WithSelectedVariantStore = WithSelectedVariantStore;
